import Head from './TopHead';
import Curric from './Curric';

function LookerStudio() {
    return (
        <main>
            <Head />

            <h1>Looker Studio (Google Data Studio)</h1>

            <section className="section">
                <h2>Looker Studio Fundamental Skills: 3 Levels</h2>

                <div className="sectional">
                    <small className="hide-print">Click to see material covered.</small>

                    <Curric title="Looker Studio Level 1 - Connecting Data and Building Your First Report (3 Hours)">
                        <ul>
                            <li>Welcome, course overview, and introduction to Google Data Studio (now Looker Studio).</li>
                            <li>Understanding the interface: navigation, report editor, view mode.</li>
                            <li>Connecting data sources: linking Google Sheets and BigQuery as primary sources.</li>
                            <li>Configuring data source fields: setting correct data types (dimensions vs. metrics), aggregation methods, and naming conventions.</li>
                            <li>Building basic visualizations: adding scorecards, tables, and simple bar charts.</li>
                            <li>Styling and theming: applying basic color palettes and layouts for a professional look.</li>
                        </ul>
                    </Curric>

                    <Curric title="Looker Studio Level 2 - Enhancing Interactivity and Advanced Visualizations (3 Hours)">
                        <ul>
                            <li>Adding interactivity: using filters, date range controls, and dimension filters to explore data dynamically.</li>
                            <li>Advanced visualizations: creating time series charts, pie charts, geo maps, and blended data tables.</li>
                            <li>Calculated fields: writing basic formulas within Data Studio to derive new metrics (e.g., profit margin, percentage of total).</li>
                            <li>Data blending: combining data from different sources or sheets on a common key (e.g., date or ID).</li>
                        </ul>
                    </Curric>

                    <Curric title="Looker Studio Level 3 - Sharing, Collaboration, and Advanced Techniques (3 Hours)">
                        <ul>
                            <li>Using functions in Data Studio.</li>
                            <li>Applying built-in functions for text manipulation, date calculations, and logical operations within calculated fields.</li>
                            <li>Sharing and collaboration: setting viewing permissions, sharing links, and scheduling email delivery of reports.</li>
                            <li>Report efficiency and optimization: understanding data freshness and how to improve report speed.</li>
                            <li>Data governance: understanding how data sources are managed and reused across an organization.</li>
                        </ul>
                    </Curric>
                </div>
            </section>

            <hr />

        </main>

    );
}

export default LookerStudio;